import { Directive, ElementRef, Input, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector:  '[lazyLoad]'
})
export class LazyLoadImageDirective {
  @Input() lazyLoad!: string;

  constructor(
    private el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngAfterViewInit() {
  if (isPlatformBrowser(this.platformId) && 'IntersectionObserver' in window) {
      const imgElement: HTMLImageElement = this.el.nativeElement;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            imgElement.src = this.lazyLoad;
            observer.unobserve(imgElement);
          }
        });
      });
      observer.observe(imgElement);
    }
  }

}
